<template>
  <v-container>
    <div class="elevation-2 px-5 mt-3">
      <SimplePageHeader title="Revenue" class="px-4 pr-5 mb-5">
      </SimplePageHeader>
      <v-row
        align="center"
        justify="start"
        class="px-5 mb-sm-5"
      >
        <v-col cols="6" sm="3" md="2">
          <v-text-field
            label="Year"
            v-model="year"
            validate-on-blur
            outlined
            :maxlength="4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="12" sm="6">
          <FilterButtons
            @search="handleSearchClick"
            @clear="handleClearClick"
          ></FilterButtons>
        </v-col>
      </v-row>
      <FilterButtonsSmall
        @search="handleSearchClick"
        @clear="handleClearClick"
      ></FilterButtonsSmall>
    </div>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-card class="pt-3">
        <v-card-text>
          <v-form ref="form" v-model="isFormValid" lazy-validation>
            <v-row>
              <v-col cols="12">
                Enter Your Revenue Goal in Dollars by Year
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="3" class="pb-0">
                <FormattedNumberField
                  label="Annual Goal"
                  :value="goalData.goal"
                  :required="true"
                  prepend-inner-icon="attach_money"
                  :validateOnBlur="true"
                  @valueChange="(newValue) => this.goalData.goal = newValue"
                ></FormattedNumberField>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                Enter Your Revenue in Dollars by Month
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <RevenueLogInput
                  :revenueLogItems="revenueLogItems"
                  @revenueLogItemsChange="(newValue) => { this.revenueLogItems = newValue }"
                ></RevenueLogInput>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
    <ButtonsSubmitForm
      :isFormValid="true"
      @save="handleSaveRevenueData"
      @cancel="cancel"
    >
    </ButtonsSubmitForm>
    <BottomSpacer></BottomSpacer>
  </v-container>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { FilterButtons, FilterButtonsSmall, BottomSpacer, ButtonsSubmitForm } from '@/components/buttons'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FormattedNumberField } from '@/components/shared/textFields'
import { dashboardRoute } from '@/lib/constants/routes'
import RevenueLogInput from './RevenueLogInput'

export default {
  components: {
    SimplePageHeader,
    FilterButtons,
    FilterButtonsSmall,
    BottomSpacer,
    ButtonsSubmitForm,
    FormattedNumberField,
    RevenueLogInput
  },
  data () {
    return {
      isFormValid: false
    }
  },
  methods: {
    ...mapActions('revenueData', [
      'getRevenueData',
      'saveRevenueData'
    ]),
    handleSearchClick () {
      this.getRevenueData()
      this.$refs.form.resetValidation()
    },
    handleClearClick () {
      this.year = new Date().getFullYear()
      this.getRevenueData()
    },
    handleSaveRevenueData () {
      if (this.$refs.form.validate()) {
        this.saveRevenueData()
      }
    },
    cancel () {
      this.$router.push(dashboardRoute)
    }
  },
  computed: {
    ...mapFields('revenueData', [
      'year',
      'goalData',
      'revenueLogItems'
    ])
  },
  mounted () {
    this.getRevenueData()
  }
}
</script>
